import { createFileRoute, Link, useLoaderData } from '@tanstack/react-router';
import { getUpsellproductsOptions } from '../../../../../features/-cart_bak/upsell-products/queryOptions';
import { useQueries, useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const Route = createFileRoute(
  '/_authenticated/cart/new/$customer/_layout/products',
)({
  component: Page,
  loader: ({ context: { queryClient }, params: { customer: guid } }) =>
    queryClient.ensureQueryData(getUpsellproductsOptions(guid)),
});

function Page() {
  const products = Route.useLoaderData();

  const customer = useLoaderData({
    from: '/_authenticated/cart/new/$customer/_layout',
  });

  return (
    <div>
      <>
        {products.response.map((product) => (
          <label>
            <input type="radio" />
            <pre>{JSON.stringify(product, null, 4)}</pre>
          </label>
        ))}
      </>
      <Link
        to="/cart/new/$customer/ob"
        params={{ customer: customer.guid }}
        search={{ guid: 'c2041311-84cf-45bb-985d-98fc98e58546' }}
      >
        Volgende
      </Link>
    </div>
  );
}
